/**
 * @flow
 * @author: Vamsi Tallam
 * */

/** *
 * TODO: need to make a common component
 */

import React, { Component } from 'react'
import {
  InputContainer,
  MainContainer,
  CustomInput,
  ErrorText,
  LabelText
} from './styledComponents'

type Props = {
  isMobile: boolean,
  validationEnabled: boolean,
  label: string,
  className: string,
  validate: func,
  placeholder: string,
  defaultValue?: string
}

class Input extends Component<Props> {
  constructor(props) {
    super(props)
    this.state = {
      value: props.defaultValue || '',
      errorMsg: this.props.required, // This is just a sample text which we won't be displaying, we will use for maintaing uniform height in all the states
      displayError: false,
      isFocused: false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.value !== this.state.value &&
      nextProps.value !== undefined &&
      nextProps.value !== null
    ) {
      this.setState({ value: nextProps.value })
    }
  }
  setError = error => {
    this.setState({ errorMsg: error })
  }
  setDisplayError = displayError => {
    this.setState({ displayError })
  }

  validate = () => {
    const { validationEnabled, validate } = this.props
    let response
    if (validationEnabled) {
      if (validate) {
        response = validate(this.state.value || '')
        if (response.displayError) {
          this.setError(response.errorMsg)
        }
        this.setDisplayError(response.displayError)
      }
    }
    return response
  }

  onFocusInput = () => {
    this.setState({
      isFocused: true,
      displayError: false,
      errorMsg: this.props.required
    })
    const { onFocus } = this.props
    if (onFocus) {
      onFocus()
    }
  }

  onBlurInput = () => {
    this.setState({
      isFocused: false
    })
    this.validate()
    const { onBlur } = this.props
    if (onBlur) {
      onBlur()
    }
  }

  onChangeInput = e => {
    const { value } = e.target
    this.setState({
      value,
      errorMsg: this.props.required,
      displayError: false
    })
  }

  render() {
    const { errorMsg, displayError, isFocused, value } = this.state
    const {
      required,
      label,
      className,
      icon: Icon,
      isMobile,
      ...other
    } = this.props
    return (
      <InputContainer {...other}>
        {label && (
          <LabelText
            id="input_label"
            displayError={displayError}
            isMobile={isMobile}
          >
            {label}
          </LabelText>
        )}
        <MainContainer
          isMobile={isMobile}
          isFocused={isFocused}
          className={className}
          value={value}
        >
          <CustomInput
            isFocused={isFocused}
            displayError={displayError}
            onFocus={this.onFocusInput}
            {...other}
            onChange={this.onChangeInput}
            value={value}
            onBlur={this.onBlurInput}
          />
        </MainContainer>
        <ErrorText as="p" displayError={displayError}>
          {errorMsg}
        </ErrorText>
      </InputContainer>
    )
  }
}

Input.defaultProps = {
  required: 'Error',
  isMobile: false,
  validationEnabled: true,
  placeholder: '',
  label: '',
  className: '',
  validate: () => {}
}

export default Input



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/EnquireNowModal/Input/index.js